class BundlePicker extends HTMLElement {
  constructor() {
    super();

    this.bundleProducts = this.querySelectorAll(".bundle_products .bundle_product");
    this.bundleDiscountName = this.dataset.bundleDiscountName;
    this.bundleSize = this.dataset.bundleSize;
    this.allBundleProductsSwatches = this.querySelectorAll(".bundle_products .bundle_product .colour-circle");
    this.lowestPrice = 0;
    this.currencySymbol = this.dataset.shopCurrencySymbol;
    this.addBundleToCartButton = this.querySelector(".bundle_button button.button");
    this.addBundleToCartButtonText = this.querySelector(".bundle_button button.button .button-text");
    this.addBundleToCartButtonSpinner = this.querySelector(".bundle_button button.button .loading-overlay__spinner");
    this.currentBundlePrice = 0;
    this.priceBeforeDiscount = 0;
    this.numberOfSelectedProducts = 0;
    this.bundleDiscount = this.dataset.bundleDiscount / 100;
    this.bundleFeaturedImage = this.dataset.featuredImage;

    this.bundleProductId = this.dataset.bundleProductId;
    this.bundleNameForLine = this.dataset.bundleNameForLine;
    this.bundleName = this.dataset.bundleName;
    this.bundleUniqueId = Math.floor(100000 + Math.random() * 900000);

    // translations
    this.addText = this.dataset.translationsAdd.toUpperCase();
    this.AtcSingle = this.dataset.translationsAtcSingle.toUpperCase();
    this.AtcMultiple = this.dataset.translationsAtcMultiple.toUpperCase();
    this.SelectText = this.dataset.translationsSelect.toUpperCase();
    this.RemoveText = this.dataset.translationsRemove.toUpperCase();
    this.singleSelected = 'ITEM SELECTED - ';
    this.multipleSelected = 'ITEMS SELECTED - ';


  }

  connectedCallback() {
    // 1. attach event listeners
    this.bundleProducts.forEach((bundleProduct) => {
      bundleProduct.addEventListener("click", this.handleSwatchClick.bind(this));

      const sizePickerItems = bundleProduct.querySelectorAll('.size-picker-item');

      sizePickerItems.forEach(item => {
        item.addEventListener('click', (e) => {
          this.handleSizeDivClick(e, bundleProduct);
        });
      });
    });

    // Automatically select one-size products
    this.bundleProducts.forEach((bundleProduct) => {
      const sizePickerItems = bundleProduct.querySelectorAll('.size-picker-item');
      if (sizePickerItems.length === 1 && sizePickerItems[0].getAttribute('data-size') === 'one-size' && !sizePickerItems[0].classList.contains('selected')) {
        sizePickerItems[0].classList.add('selected');
        this.handleSizeDivClick({ currentTarget: sizePickerItems[0], target: sizePickerItems[0], preventDefault: () => {} }, bundleProduct, { suppressSwatchDrawer: true });
      }
    });

    // Adds a click event to each colour selector button in every bundle product
    // When clicked it checks the currently selected size and shows the matching swatch drawer for that size
    this.bundleProducts.forEach((bundleProduct) => {
      const colourSelector = bundleProduct.querySelector('.select-message__colour');
      if (colourSelector) {
        colourSelector.addEventListener('click', () => {
          // Get the selected size for this bundle product
          const selectedSizeBtn = bundleProduct.querySelector('.size-picker-item.selected');
          let selectedSize = '';
          if (selectedSizeBtn) {
            selectedSize = selectedSizeBtn.getAttribute('data-size');
          }

          const swatchesContainer = bundleProduct.querySelectorAll('.swatches');
          swatchesContainer.forEach((swatch) => {
            this.updateMainContentActive(true);
            setTimeout(function() {
              if (selectedSize && swatch.classList.contains(selectedSize)) {
                swatch.classList.add('active');
              } else {
                swatch.classList.remove('active');
              }
            }, 500);
          });
        });
      }
    });

    // Size-colour picker accordion
    const accordion = document.getElementById('bundle-accordion');
    if (!accordion) return;

    const buttons = accordion.querySelectorAll('.accordion-button');
    const contents = accordion.querySelectorAll('.accordion-content');

    buttons.forEach((btn, idx) => {
      btn.addEventListener('click', function() {
        const bundleProduct = btn.closest('.bundle_product');
        if (!bundleProduct.classList.contains('unselected')) {
          if (btn.getAttribute('aria-expanded') === 'true') {
            return;
          }
        }

        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          if (bundleProduct.classList.contains('unselected')) {
            btn.setAttribute('aria-expanded', 'false');
            contents[idx].classList.remove('active')
          }
        } else {
          btn.setAttribute('aria-expanded', 'true');
          contents[idx].classList.add('active')
        }
      });
    });

    // Size picker popup
    const sizeSelectors = document.querySelectorAll('.select-message__size');

    sizeSelectors.forEach((sizeSelector) => {
      sizeSelector.addEventListener('click', () => {
        let bundleInfo = sizeSelector.closest('.bundle_product--info');

        bundleInfo.querySelector('.drawer').classList.add('active', 'animate')
        this.updateMainContentActive(true);
      })
    })

    // Close popup picker
    const closeBundles = document.querySelectorAll('.drawer__close-bundle');

    closeBundles.forEach((closeBundle) => {
      closeBundle.addEventListener('click', () => {
        closeBundle.closest('.drawer').classList.remove('active');
        this.updateMainContentActive();
      });
    })

    this.addBundleToCartButton.addEventListener("click", this.handleAddBundleToCart.bind(this));
    // 2. find product with the lowets price
    this.findLowestPrice();
    // 3. update price next to bundle/product Title
    // this.updatePriceNextToTitle();
    this.updateMainContentActive();
  }

  // Kkeep #MainContent.active in sync with drawers
  updateMainContentActive(forceActive = false) {
    const mainContent = document.querySelector('#MainContent');
    if (!mainContent) return;
    if (forceActive) {
      mainContent.classList.add('active');
      return;
    }

    const anyDrawerActive = document.querySelectorAll('.drawer.active').length > 0;
    if (anyDrawerActive) {
      mainContent.classList.add('active');
    } else {
      mainContent.classList.remove('active');
    }
  }

  // Handles swatch click
  handleSwatchClick(e) {
    // if swatch is sold out, or user didn't click swatch, return
    if (e.target.classList.contains("swatch-sold-out")) return;
    if (!e.target.classList.contains("colour-circle")) return;
    // select swatch
    this.handleSwatchSelect(e.target);
  }

  // Handles size change
  handleSizeDivClick(e, bundleProduct, { suppressSwatchDrawer = false } = {}) {
    const selectedBundleProduct = e.currentTarget.closest('.bundle_product');

    if (selectedBundleProduct.classList.contains('unselected')) {
      selectedBundleProduct.classList.remove('unselected');
    }

    // Remove 'selected' class from all size-picker-items in this bundleProduct
    bundleProduct.querySelectorAll('.size-picker-item').forEach(item => {
      item.classList.remove('selected');
    });

    e.currentTarget.classList.add('selected');

    e.currentTarget.closest('.swatches-size-selector').classList.remove('active');
    this.updateMainContentActive();

    // Set a data attribute or property to store the selected size
    const selectedSize = e.currentTarget.getAttribute('data-size');
    const selectedSizeName = e.currentTarget.getAttribute('data-size-name');

    const selectMessage = bundleProduct.querySelector(".select-message .select-message__size p");
    selectMessage.innerHTML = selectedSizeName;

    // Remove 'selected' from all colour options in this bundleProduct
    bundleProduct.querySelectorAll('.colour-circle').forEach(circle => {
      circle.classList.remove('selected');
    });

    // Reset the select-message__colour button
    const colourBtn = bundleProduct.querySelector('.select-message__colour');
    const colourOption = bundleProduct.querySelector('.select-message__colour-option');
    const colourLabel = bundleProduct.querySelector('.select-message__colour p');

    if (colourLabel) {
      colourLabel.textContent = 'Colour';
      colourLabel.classList.add('unselected');
    }

    if (colourOption) {
      // Remove any bg- classes
      colourOption.className = 'select-message__colour-option';
    }

    // Make colour option available if a size is selected, otherwise inactive
    if (selectedSize && selectedSize !== 'deselected') {
      if (colourBtn) colourBtn.classList.remove('inactive');
    } else {
      if (colourBtn) colourBtn.classList.add('inactive');
    }

    // Show/hide swatches for this size (mimic select logic)
    const swatchesContainer = bundleProduct.querySelectorAll(".swatches");
    swatchesContainer.forEach((swatch) => {
      this.updateMainContentActive(true);
       setTimeout(function() {
          if (!suppressSwatchDrawer) {
            swatch.classList.contains(selectedSize) ? swatch.classList.add("active") : swatch.classList.remove("active");
          } else {
            // On auto selecting dont open drawer
            swatch.classList.remove("active");
          }
        }, 500);
    });

    // If "deselected" or "one-size", handle accordingly
    if (selectedSize === "deselected" || selectedSize === "one-size") {
      swatchesContainer[0].classList.remove("hidden");
    } else {
      // Auto-select first swatch for this size
      const firstSwatch = bundleProduct.querySelector(`.swatches.${selectedSize} li .colour-circle:not(.swatch-sold-out)`);
      if (firstSwatch) firstSwatch.click();
    }

    this.updateNumberOfSelectedProducts();
    this.updateCurrentBundleTotalPrice();
    this.updateDiscountedBundleProductsPrices();
    this.updateAddBundleToCartButton();
    this.updatePriceNextToTitle();
  }

  // Handles colour change
  handleSwatchSelect(targetElement) {
    // Get all variables
    const product = targetElement.closest(".bundle_product");
    const productAccordionTitle = product.querySelector('.accordion-button span');
    const productImage = product.querySelector(".bundle_product--image img");
    const productSwatchName = product.querySelector(".select-message .select-message__colour p");
    const productSwatchColour = product.querySelector(".select-message__colour-option");
    const productPriceEl = product.querySelector(".price-wrapper .price");
    const featuredImage = targetElement.dataset.featuredImage;
    const swatchName = targetElement.dataset.swatchName;
    const productPrice = targetElement.dataset.productPrice;
    const productTitle = targetElement.dataset.productTitle;
    const productPriceWrapperEl = product.querySelector(".price-wrapper");

    // update UI
    productPriceWrapperEl.classList.remove("hidden");
    productImage.src = featuredImage;
    productSwatchName.innerHTML = swatchName;
    // if (productAccordionTitle && productTitle) {
    //   productAccordionTitle.innerHTML = productTitle;
    // }

    // Remove any previous bg- classes
    productSwatchColour.classList.forEach(cls => {
      if (cls.startsWith('bg-')) {
        productSwatchColour.classList.remove(cls);
      }
    });

    productSwatchColour.classList.add('bg-' + swatchName.toLowerCase());

    productPriceEl.innerHTML = productPrice;
    product.querySelectorAll(".colour-circle").forEach((circle) => {
      circle.classList.remove("selected");
    });
    targetElement.classList.add("selected");

    // close it down
    targetElement.closest('.drawer').classList.remove('active');
    this.updateMainContentActive();

    // Automatically open up the next item accordion
    const currentBundleProduct = targetElement.closest('.bundle_product');
    const nextBundleProduct = currentBundleProduct.nextElementSibling;
    if (nextBundleProduct && nextBundleProduct.classList.contains('bundle_product')) {
      const nextAccordionButton = nextBundleProduct.querySelector('.accordion-button');
      const nextAccordionContent = nextBundleProduct.querySelector('.accordion-content');
      if (nextAccordionButton && nextAccordionContent) {
        nextAccordionButton.setAttribute('aria-expanded', 'true');
        nextAccordionContent.classList.add('active');
      }
    }

    // If theres no featured bundle image use the default image instead
    let bundleImageUrl = targetElement.getAttribute('data-featured-bundle-image');
    if (!bundleImageUrl) {
      bundleImageUrl = targetElement.getAttribute('data-featured-bundle-image-backup');
    }

    if (bundleImageUrl) {
      // Find the bundle position (js-bundle-position-X)
      const bundleProduct = targetElement.closest('.bundle_product');
      if (bundleProduct) {
        const positionClass = Array.from(bundleProduct.classList).find(cls => cls.startsWith('js-bundle-position-'));
        if (positionClass) {
          const position = parseInt(positionClass.replace('js-bundle-position-', ''), 10);

          // Find the gallery image at this position (nth-child)
          const galleryList = document.querySelector('.js-bundle-gallery');

          if (galleryList) {
            const galleryItem = galleryList.querySelector(`.bundle-images__item.index-${position}`);
            if (galleryItem) {
              galleryItem.querySelector('img').src = bundleImageUrl;
              galleryItem.querySelector('img').srcset = bundleImageUrl;
            }
          }
        }
      }
    }

    // Update number of selected products
    this.updateNumberOfSelectedProducts();
    // Update current bundle price
    this.updateCurrentBundleTotalPrice();
    // Update add bundle to cart button
    this.updateAddBundleToCartButton();
    // Update price next to bundle/product Title
    this.updatePriceNextToTitle()
  }

  // Finds product with the lowest price
  findLowestPrice() {
    this.allBundleProductsSwatches.forEach((swatch) => {
      const price = swatch.dataset.productPrice;
      const moneyValue = this.extractMoneyValue(price);
      if (moneyValue < this.lowestPrice || this.lowestPrice === 0) {
        this.lowestPrice = moneyValue;
      }
    });
  }

  totalLowestPrice() {
    let totalLowestPrice = 0;
    this.bundleProducts.forEach((bundleProduct) => {
      const swatches = bundleProduct.querySelectorAll(".colour-circle");
      let lowestPriceForProduct = 0;
      swatches.forEach((swatch) => {
        const price = swatch.dataset.productPrice;
        const moneyValue = this.extractMoneyValue(price);
        if (moneyValue < lowestPriceForProduct || lowestPriceForProduct === 0) {
          lowestPriceForProduct = moneyValue;
        }
      });
      totalLowestPrice += lowestPriceForProduct;
    });
    return totalLowestPrice;
  }

  // Extracts money value from string ex: $10.00 -> 10.00
  extractMoneyValue(inputString) {
    return Number(inputString.replace(this.currencySymbol, ""))
  }

  // Updates add bundle to cart button
  updateAddBundleToCartButton() {
  // Only enable the button if all bundle products have a selected swatch
  if (this.numberOfSelectedProducts === this.bundleProducts.length) {
    this.addBundleToCartButton.removeAttribute("disabled");
    this.addBundleToCartButtonText.innerHTML = `${this.addText} ${this.numberOfSelectedProducts} ${this.AtcSingle } ${this.currencySymbol}${this.currentBundlePrice}`;
  } else if (this.numberOfSelectedProducts < this.bundleProducts.length && this.numberOfSelectedProducts == 1) {
    this.addBundleToCartButtonText.innerHTML = `${this.numberOfSelectedProducts} ${this.singleSelected} ${this.currencySymbol}${this.currentBundlePrice}`;
  } else if (this.numberOfSelectedProducts < this.bundleProducts.length && this.numberOfSelectedProducts > 0) {
    this.addBundleToCartButtonText.innerHTML = `${this.numberOfSelectedProducts} ${this.multipleSelected} ${this.currencySymbol}${this.currentBundlePrice}`;
  } else {
    this.addBundleToCartButton.setAttribute("disabled", "disabled");
    this.addBundleToCartButtonText.innerHTML = `SELECT YOUR ITEMS`;
  }
}

  // Updates discounted bundle products prices
  updateDiscountedBundleProductsPrices(targetElement, selectedSwatch) {
    // loop through all bundle products and find the selected swatch
    this.allBundleProductsSwatches.forEach((swatch) => {
      // if swatch is selected
      if (this.numberOfSelectedProducts == this.bundleProducts.length) {
        if (swatch.classList.contains("selected")) {
          const parentEl = swatch.closest(".bundle_product");
          const priceEl = parentEl.querySelector(".price-wrapper .price");
          const originalPriceEl = parentEl.querySelector(".price-wrapper .original-price");

          const swatchExtractedPrice = this.extractMoneyValue(swatch.dataset.productPrice);

          const discountedPriceValue = swatchExtractedPrice - swatchExtractedPrice * this.bundleDiscount;
          // update current bundle price with discount
          const productDiscountedPrice = discountedPriceValue.toFixed(2);

          priceEl.innerHTML = `${this.currencySymbol}${productDiscountedPrice}`;
          originalPriceEl.innerHTML = swatch.dataset.productPrice;
          originalPriceEl.classList.remove("hidden");
        }
      } else {
        if (swatch.classList.contains("selected")) {
          const parentEl = swatch.closest(".bundle_product");
          const priceEl = parentEl.querySelector(".price-wrapper .price");
          const originalPriceEl = parentEl.querySelector(".price-wrapper .original-price");

          priceEl.innerHTML = swatch.dataset.productPrice;
          originalPriceEl.classList.add("hidden");
        }
      }
    });
    // In above code we run through all swatches with 'selected' class and update the UI
    // but because when unselecting there is a product without 'selected' class(that we still
    // neee to update) So we have to target that one too(it's passed as an argument when deselecting)
    if (this.numberOfSelectedProducts < this.bundleProducts.length) {
      if (!targetElement) return;

      const parentEl = targetElement.closest(".bundle_product");
      const priceEl = parentEl.querySelector(".price-wrapper .price");
      const originalPriceEl = parentEl.querySelector(".price-wrapper .original-price");
      if(selectedSwatch) priceEl.innerHTML = selectedSwatch.dataset.productPrice;
      originalPriceEl.classList.add("hidden");
    }
  }

  // Updates current bundle price
  updateCurrentBundleTotalPrice() {
    // loop through all bundle products and find the selected swatch
    let totalPrice = 0;
    this.allBundleProductsSwatches.forEach((swatch) => {
      // if swatch is selected
      if (swatch.classList.contains("selected")) {
        // Get price from data attribute
        const price = swatch.dataset.productPrice;
        // Extract the money value from the price string
        const moneyValue = this.extractMoneyValue(price);
        // Add money value to total price
        totalPrice = totalPrice + moneyValue;
      }
    });

    // if all products are selected, apply discount
    if (this.numberOfSelectedProducts == this.bundleProducts.length) {
      // total discounted price
      const discountedPrice = totalPrice - totalPrice * this.bundleDiscount;
      // update current bundle price with discount
      this.currentBundlePrice = discountedPrice.toFixed(2);
      this.updateDiscountedBundleProductsPrices();
    } else {
      // if not all products are selected, do not apply discount
      this.currentBundlePrice = totalPrice;
    }
  }

  // Updates price next to bundle/product Title
  updatePriceNextToTitle() {
    return;
    const priceNextToTitleEl = document.querySelector("product-info .bundle-js-price") || document.querySelector("product-info .price__from"); // fallback to old element if bundle-js-price doesn't exist
    const discountedPriceEl = document.querySelector("product-info .bundle-js-discounted-price");
    const priceFromTextEl = document.querySelectorAll("product-info .bundle--price .price__from");
    console.log(priceNextToTitleEl, discountedPriceEl, priceFromTextEl);
    if (priceFromTextEl.length > 0) {
      priceFromTextEl.forEach(el => el.style.display = "none");
    }
    let priceBeforeDiscount = 0;
    // calculate price before discount
    this.allBundleProductsSwatches.forEach((swatch) => {
      // if swatch is selected
      if (swatch.classList.contains("selected")) {
        // Get price from data attribute
        const price = swatch.dataset.productPrice;
        // Extract the money value from the price string
        const moneyValue = this.extractMoneyValue(price);
        // Add money value to total price
        priceBeforeDiscount = priceBeforeDiscount + moneyValue;
        this.priceBeforeDiscount = priceBeforeDiscount.toFixed(2);
      }
    });
    if (this.numberOfSelectedProducts == 0) {
      priceNextToTitleEl.innerHTML = `From ${this.currencySymbol}${this.totalLowestPrice().toFixed(2)}`;
      if (discountedPriceEl) discountedPriceEl.style.display = "none";
    } else if (this.numberOfSelectedProducts > 0 && this.numberOfSelectedProducts < this.bundleProducts.length) {
      priceNextToTitleEl.innerHTML = `${this.currencySymbol}${this.currentBundlePrice.toFixed(2)}`;
      if (discountedPriceEl) discountedPriceEl.style.display = "none";
    } else {
      if (discountedPriceEl) {
        discountedPriceEl.style.display = "block";
        discountedPriceEl.innerHTML = `${this.currencySymbol}${this.currentBundlePrice.toFixed(2)}`;
      }
      priceNextToTitleEl.innerHTML = `${this.currencySymbol}${this.priceBeforeDiscount}`;
    }
  }

  // Updates number of selected products
  updateNumberOfSelectedProducts() {
    // loop through all bundle products and find the selected swatch
    let selected = 0;
    const swatches = this.querySelectorAll(".bundle_products .bundle_product:not(.unselected) .colour-circle");
    swatches.forEach((swatch) => {
      // if swatch is selected
      if (swatch.classList.contains("selected")) {
        selected++;
      }
    });
    this.numberOfSelectedProducts = selected;

  }

  // Adds bundle to cart
  handleAddBundleToCart() {
    this.addBundleToCartButton.classList.add("disabled");
    this.addBundleToCartButtonText.classList.add("hidden");
    this.addBundleToCartButtonSpinner.classList.remove("hidden");

    const addToCartItems = [];

    let bundleParts = '';
    let bundlePartsIDs = '';
    const randomID = Math.floor(100000 + Math.random() * 900000);

    this.allBundleProductsSwatches.forEach((swatch) => {
      // if swatch is selected
      if (swatch.classList.contains("selected")) {
        bundleParts = bundleParts + swatch.dataset.productTitle + ',';
        bundlePartsIDs = bundlePartsIDs + swatch.dataset.productId + ',';
      }
    });

    let bundle_product_ids = '';
    // Loop through all bundle products and find the selected swatch
    this.allBundleProductsSwatches.forEach((swatch) => {
      // if swatch is selected
      if (swatch.classList.contains("selected")) {
        // Get product id from data attribute
        const productId = swatch.dataset.productId;
        // Add product id to bundle_product_ids
        bundle_product_ids = bundle_product_ids + productId + ',';
        // Add product to product array with line item properties
        addToCartItems.push({
          id: Number(productId),
          quantity: 1,
          properties: {
            _bundleAntlerID: `${this.bundleName}-${randomID}`,
            _bundleSize: this.bundleSize,
            _parentProductID: Number(this.bundleProductId),
            _bundleDiscountName: this.bundleDiscountName,
            _bundleParentTitle: this.bundleNameForLine
          },
        });
      }
    });
    // remove last comma
    bundle_product_ids = bundle_product_ids.slice(0, -1);

    const items = {
      items: addToCartItems,
      sections: "cart-drawer,cart-icon-bubble",
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      body: JSON.stringify(items),
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        const parser = new DOMParser();

        //removing current cart-drawer section and replacijng it with newly fetched one
        document.querySelector("#shopify-section-cart-drawer").remove();
        document.querySelector("main-content").insertAdjacentHTML("beforeend", json.sections["cart-drawer"]);

        // transforming response and quering the icon count bubble
        const htmlTextCartIcon = json.sections["cart-icon-bubble"];
        const htmlCartIcon = parser.parseFromString(htmlTextCartIcon, "text/html");
        const bubbleCount = htmlCartIcon.querySelector("div.cart-count-bubble");

        //selecting existing icon count bubble
        const iconCartCountEl = document.querySelector("div.cart-count-bubble");

        // if it exists remove
        if (iconCartCountEl) {
          iconCartCountEl.remove();
        }

        // inserting new icon buuble count
        if(bubbleCount) document.querySelector(".header__icon.header__icon--cart").appendChild(bubbleCount);
      })
      .catch(function (err) {
        /* uh oh, we have error. */
        console.error(err);
      })
      .finally(() => {
        // button classes
        this.addBundleToCartButton.classList.remove("disabled");
        this.addBundleToCartButtonText.classList.remove("hidden");
        this.addBundleToCartButtonSpinner.classList.add("hidden");
        // opening cart-drawer
        document.querySelector("cart-drawer").classList.add("drawer", "animate", "active");
        // deselect all bundle items
        this.bundleProducts.forEach((bundleProduct) => {
          bundleProduct.querySelector(".size_picker").value = "deselected";
          bundleProduct.dispatchEvent(new Event("change"));
        })

      });
  }
}

customElements.define("bundle-picker", BundlePicker);
